import { useSelector } from "react-redux";
import { FAQBackground } from "../../constants/ImagePaths";
import Accordian from "../../components/general/Accordian";

const FAQSection = ({ selected_skill }) => {
    const backgroundStyles = {
        backgroundImage: `url(${FAQBackground})`,
        backgroundPosition: 'initial',
        backgroundRepeat: 'repeat',
        position: 'relative',
        zIndex: '1',
    }

    const { faqsListByRoleSkills } = useSelector(state => state.home);

    if (!faqsListByRoleSkills?.length) return null;
    
    return (
        <section className="--layout-padding !pt-[50px] md:!pt-[100px] !pb-[50px] lg:!pb-[100px] lg:!pt-[100px] lg:min-h-[800px]" style={backgroundStyles}>
            <div className="text-white">
                <div className="faqCon">
                    <h3 className="text-[30px] lg:text-55 text-center font-semibold">FAQ about hiring <span className="text-primary-color"> {selected_skill}</span> </h3>
                    <div className="mt-[30px]" id="accordionExample">
                        {
                            Boolean(faqsListByRoleSkills?.length) && faqsListByRoleSkills.map((faq) => {
                                return (
                                    <div key={faq.id} className="lg:w-[70%] lg:mx-auto my-[30px]">
                                        <Accordian key={faq.id} title={faq.question} content={faq.answer} bordered />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};
export default FAQSection;